import { takeEvery, fork, put, all, call } from 'redux-saga/effects'

import fetch from './../../fetch'
import { baseURL, commonHeaders } from '../../../../Containers/Confiq/index.js'

import {
  GET_COUPON,
  GET_COUPON_SUCCESS,
  GET_COUPON_ERROR,
} from './../../actionType.js'

function* getCoupon({ payload }) {
  try {
    const response = yield call(fetch, {
      url: `${baseURL}/parse/classes/golfbookings/?where=${payload.param}`,
      method: 'GET',
      // headers: { ...commonHeaders },
    })

    if (response?.error === undefined) {
      yield put({ type: GET_COUPON_SUCCESS, payload: response })
    } else {
      yield put({ type: GET_COUPON_ERROR, payload: response.error })
    }
  } catch (error) {
    yield put({ type: GET_COUPON_ERROR, payload: error })
  }
}

export function* watchGetCoupon() {
  yield takeEvery(GET_COUPON, getCoupon)
}

function* getCouponSaga() {
  yield all([fork(watchGetCoupon)])
}

export default getCouponSaga
